import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import {
  DocumentsRequest,
  DocumentsResponse,
  ProjectTask,
  SelectedFile,
  UpdateDocumentProcessorRequest,
} from '@aksia/models';
import { HttpClient } from '@angular/common/http';
import { ENVIRONMENT_TOKEN } from '@aksia/infrastructure';
import { CedricApiService } from '../../infrastructure/api/cedric.api.service';

@Injectable({
  providedIn: 'root',
})
export class DocumentManagerService {
  private readonly documentManagerUrl = 'ProjectDocumentManager';
  private api = inject(CedricApiService);
  private http = inject(HttpClient);
  private environment = inject(ENVIRONMENT_TOKEN);

  getAdditionalInformationFromServer(): Observable<any> {
    const url = this.documentManagerUrl + '/GetAdditionalInformation';
    return this.api.post(url, {});
  }

  getProjectDocuments(
    request: DocumentsRequest,
  ): Observable<DocumentsResponse> {
    const url = this.documentManagerUrl + '/GetProjectDocumentsFromIndex';
    //return of(this.data);
    return this.api.post(url, { request });
  }

  exportExcel(name: string, type: string, request: any): Observable<any> {
    const url =
      this.environment.report_service_url +
      `/ExcelExport/Export?name=${name}&exportClassName=${type}`;
    return this.http.post(
      url,
      {
        exportRequest: request,
      },
      {
        withCredentials: true,
        responseType: 'blob',
      },
    );
  }

  updateDocumentProcessor(projectTask: ProjectTask): Observable<any> {
    const url = this.documentManagerUrl + '/UpdateDocumentProcessor';
    return this.api.post(url, projectTask);
  }

  updateDocumentProcessorBundle(
    request: UpdateDocumentProcessorRequest,
  ): Observable<any> {
    const url = this.documentManagerUrl + '/UpdateDocumentProcessorBundle';
    return this.api.post(url, request);
  }

  getExcelFromAIWithScheduleOfInvestments(
    projectId: number,
    dataDefinitionId: number,
    fileName: string,
    ext: string,
    startPage?: number,
    endPage?: number,
  ): Observable<any> {
    const url = `${this.environment.cedric_api_url}/${this.documentManagerUrl}/GetExcelFromAIWithScheduleOfInvestments`;
    return this.http.post(
      url,
      {
        projectId,
        dataDefinitionId,
        fileName,
        ext,
        scheduleOfInvestmentsStartingPage: startPage,
        scheduleOfInvestmentsEndingPage: endPage,
      },
      { withCredentials: true, observe: 'response', responseType: 'blob' },
    );
  }

  getSelectedFiles(requestData: SelectedFile[]): Observable<any> {
    const url = `${this.environment.cedric_api_url}/${this.documentManagerUrl}/GetSelectedFiles`;
    return this.http.post(
      url,
      { files: requestData },
      {
        withCredentials: true,
        responseType: 'blob',
      },
    );
  }
}
